import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import App from "./components/App";

// --- Microsoft Clarity (inline loader) ---
(function (c, l, a, r, i, t, y) {
  c[a] =
    c[a] ||
    function () {
      (c[a].q = c[a].q || []).push(arguments);
    };
  t = l.createElement(r);
  t.async = 1;
  t.src = "https://www.clarity.ms/tag/t5bdbvmirv";
  y = l.getElementsByTagName(r)[0];
  y.parentNode.insertBefore(t, y);
})(window, document, "clarity", "script", "clarity");
// -----------------------------------------

// ✅ Load Google Maps (Places API) using standard script loader
function loadGoogleScript(callback) {
  const existingScript = document.getElementById("googleMaps");
  if (!existingScript) {
    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyAUjzKOLtrcZlyh0l_XqZdrvYSlwOE_hNg&libraries=places&language=en&region=AU";
    script.id = "googleMaps";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    script.onload = callback;
  } else if (callback) {
    callback();
  }
}

// ✅ Initialize your React app only after Google API is ready
loadGoogleScript(() => {
  console.log("✅ Google Places script loaded globally");

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
